export type ComposeCidParams = {
  channelType: string;
  channelId: string;
};

export const composeCid = ({ channelType, channelId }: ComposeCidParams) => {
  return `${channelType}:${channelId}`;
};
